/* eslint-disable @typescript-eslint/no-unused-vars */
import { useState } from "react";
import { CustomAccordianWrapper } from "../../styles/StyledComponents/CustomAccordianWrapper";
import PlusIcon from "../../ui/icons/PlusIcon";
import { CustomAccordionProps } from "../../ui/interface";

const CustomAccordion = ({ items }: CustomAccordionProps) => {
  const [expandedId, setExpandedId] = useState<string | number | null>(null);

  const handleToggle = (id: number | string) => {
    setExpandedId((prev) => (prev === id ? null : id));
  };

  return (
    <CustomAccordianWrapper>
      <div className="accordionWrap">
        {items.map((item,index) => (
          <div
            key={index}
            className={`accordionItem ${expandedId === item.id ? "expanded" : ""}`}
          >
            <div
              className="accordionHeader"
              onClick={() => handleToggle(item.id)}
            >
              <span>{item.title}</span>
              <i className={`arrow ${expandedId === item.id ? "rotate" : ""}`}>
                <PlusIcon />
              </i>
            </div>
            <div className="accordionBody">
              <div className="accordionContent">{item.content}</div>
            </div>
          </div>
        ))}
      </div>
    </CustomAccordianWrapper>
  );
};

export default CustomAccordion;
